<template>
    <div class="row">
        <div
            v-if="loading"
            class="col-12 mt-5"
            v-loading="true"></div>
        <div v-else class="col-12">
            <card>
                <template slot="header">
                    Edit Roles
                </template>
                <el-form label-width="300px">
                    <el-form-item
                        v-for="key in Object.keys(permissions)"
                        :key="`permission-${key}`"
                        v-if="key !== 'preventUserFromEditingRegistrationsCreatedAfterDate'"
                        :label="formatLabel(key)">
                            <el-checkbox v-model="permissions[key]"/>
                    </el-form-item>
                    <el-form-item :label="formatLabel('preventUserFromEditingRegistrationsCreatedAfterDate')">
                        <el-checkbox @input="handleChange" v-model="permissions['preventUserFromEditingRegistrationsCreatedAfterDate'].value"/>
                    </el-form-item>
                    <el-form-item style="width: 40%" :label="formatLabel('specify Date')" v-if="permissions['preventUserFromEditingRegistrationsCreatedAfterDate'].value">
                        <el-date-picker type="datetime" v-model="permissions['preventUserFromEditingRegistrationsCreatedAfterDate'].date" />
                    </el-form-item>
                </el-form>
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            type="primary"
                            class="btn btn-primary"
                            :loading="saving"
                            @click="submit()">
                                Save
                        </el-button>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '../../http.js'

export default {
    data () {
        return {
            loading: true,
            saving: false,
            user: {},
            event: {},
            permissions: {
                viewRegistrants: false,
                viewTransactionSummary: false,
                allowStatusChanges: false,
                editPaymentsForRegistrants: false,
                allowApplyingManualDiscountsForRegistrations: false,
                createCustomFields: false,
                viewCustomFields: false,
                editCustomFields: false,
                createRegistrationTypes: false,
                viewRegistrationTypes: false,
                editRegistrationTypes: false,
                checkinRegistrants: false,
                checkinActivities: false,
                viewDashboard: false,
                sendMassEmails: false,
                viewUsers: false,
                editUsers: false,
                viewReports: false,
                downloadReports: false,
                settings: false,
                specialAdminPrivilegeForCertainFields: false,
                accessToTemplates: false,
                preventUserFromEditingRegistrationsCreatedAfterDate: {
                    value: false,
                    date: null
                },
                changeRegistrationTypeForRegistrant: false,
                createCheckpoints: false,
                editCheckpoints: false,
                viewAndCreateCheckinsForCheckpoints: false
            }
        }
    },
    computed: {
        // ...mapState([
        //     'event'
        // ])
    },
    mounted () {
        this.getUser()
    },
    methods: {
        handleChange(val){
            if(val == false){
                this.permissions.preventUserFromEditingRegistrationsCreatedAfterDate.date = null
            }
        },
        formatLabel: (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase()),
        getUser: async function () {
            this.loading = true
            try {
                const evt = await http.get(`/api/events/${this.$route.params.eventId}`)
                this.event = (evt.data && evt.data.event && evt.data.event.admins) ? evt.data.event : {}

                const response = await http.get(`/api/users/${this.$route.params.userId}`)
                this.user = response.data.user

                if (this.event.adminRoles && this.event.adminRoles[this.user._id]) {
                    this.permissions = {
                        ...this.permissions,
                        ...this.event.adminRoles[this.user._id]
                    }
                }
            } catch (e) {
                console.log(e)
                console.log('error getting user')
            }
            this.loading = false
        },
        submit: async function () {
            this.saving = true
            try {
                if (!this.event.adminRoles) {
                    this.event.adminRoles = {}
                }

                if (!this.user.roles) {
                    this.user.roles = {}
                }

                this.event.adminRoles[this.user._id] = this.permissions
                this.user.roles[this.event._id] = this.permissions

                await Promise.all([
                    this.$store.dispatch('update', {
                        path: 'events',
                        data: this.event,
                        id: this.event._id
                    }),
                    http.put(`/api/users/${this.user._id}`, this.user)
                ])
                this.$notify('Successfully updated!')
            } catch (e) {
                console.log(e)
                console.log('error updating user')
            }
            this.saving = false
        }
    }
}
</script>
